import { jsx as o } from "theme-ui";
const s = (p) => `${p}px`, E = (p, _) => o(
  p.props.__EMOTION_TYPE_PLEASE_DO_NOT_USE__ ?? p.type,
  {
    key: p.key,
    // @ts-expect-error
    ref: p.ref,
    ...p.props,
    ..._
  }
);
export {
  E as cloneElementWithCss,
  s as pixelize
};
